import axios from "axios"
import { 
    CheckDomainResponse, 
    LogoDataResponse, 
    LogoData, 
    NameGeneratorResponse, 
    LDLogoDataResponse,
    LDSymbolResponse
 } from "./types"

const BASE_URL = process.env.REACT_APP_BASE_URL
const API_URL = process.env.REACT_APP_API_URL
const APP_NAME = process.env.REACT_APP_NAME

export const textLogoLimit = 15

export async function fetchLogos(company: string, keywords: string[] | null, limit: number, page: number): Promise<LogoDataResponse> {
    let url = ""
    // TODO: handle for FLC
    if (keywords === null) {
        url = `${BASE_URL}/logos`
    } else {
        const keywordsSlug = keywords.join("-")
        url = `${BASE_URL}/logos/${keywordsSlug.toLowerCase()}`
    }
    if (APP_NAME === "LD") {

        const response = await axios.get<LDLogoDataResponse>(url, {
            params: {
                companyName: company,
                appName: "bng",
                perPageNew: limit,
                page
            }
        })

        const logoData: LogoData[] = response.data.logoData?.map((item) => {
            return {
                img_url: item.imageURL,
                studio_url: item.studioURL,
                id: item.symbol
            }
        }) || []
        return {
            data: logoData,
            total: logoData.length
        }
    } else {
        let data: LogoDataResponse
        const origin = "flc"
        const api_resp = await axios.get<LogoDataResponse>(`${BASE_URL}/fetch-logos`, {
            // TODO: should send multiple keywords to FLC
            params: {
                company: encodeURIComponent(company),
                keyword: keywords == null ? "" : keywords[0],
                limit,
                origin,
                page
            }
        })
        data = api_resp.data
        return data
    }
}

export async function checkDomain(domainName: string, tlds: string[]) {
    return await axios.post<CheckDomainResponse>(`${API_URL}/check-domain`, {
        tlds,
        domainName
    })
}

export async function fetchGeneratedWords(keywords: string[]) {
    const response = await axios.get<NameGeneratorResponse>(`${API_URL}/generate-names`, {
        params: {
            keywords: keywords.join(",")
        }
    })
    return response.data
}

export async function fetchTextLogos(companyName: string) {
    // TODO: handle this for FLC

    // if (APP_NAME === "LD") {
        const response = await axios.get<LDLogoDataResponse>(`${BASE_URL}/logos/text`, {
            params: {
                companyName,
                appName: "bng",
                perPageNew: textLogoLimit,
            }
        })

        const logoData: LogoData[] = response.data.logoData.map((item) => {
            return {
                img_url: item.imageURL,
                studio_url: item.studioURL,
                id: item.symbol
            }
        })
        return {
            data: logoData,
            total: logoData.length
        }

    // }
}

export async function fetchSingleLogoData(symbol: string, companyName: string) {
    // TODO: handle for FLC
    const response = await axios.get<LDSymbolResponse>(`${BASE_URL}/api/get_symbol/${symbol}`, {
        params: {
            companyName: companyName
        }
    })

    const logoData: LogoData = {
        studio_url: response.data.studioURL,
        img_url: response.data.imageURL,
        id: response.data.id
    }

    return logoData
}
